import { Grid, GridColumn } from "semantic-ui-react";

import { DatePicker, DealersAndLocationsDropdown, ExportDataButton, NavPortal, ResetFiltersButton, SearchFilter, useCan } from "components";
import { usePermanentRealTimeUser } from "hooks";
import { ACL_ACTIVITIES, ACL_RESOURCES } from "models";
import { LeadTypeFilter, LeadsExportModal } from "modules/LeadsDashboard/components";
import { useExportModal } from "modules/LeadsDashboard/hooks";
import { CustomDateRangeInput } from "modules/LeadsDashboard/Leads/CarsLeads/components";
import "modules/LeadsDashboard/Leads/CarsLeads/components/CarsLeadsFilters/CarsLeadsFilters.scss";
import { exportLeadsCars, useCarsFilterHandlers } from "modules/LeadsDashboard/Leads/CarsLeads/hooks";

export const CarsLeadsFilters = () => {
  const { user } = usePermanentRealTimeUser();
  const canExportLeads = useCan(ACL_ACTIVITIES.Export, ACL_RESOURCES.LeadsCars);

  const { handleCloseExportModal, handleOpenExportModal, showExportModal } = useExportModal();
  const { handleDateRangeChange, handleDealerLocationChange, handleResetFilters, handleSearchChange, carsFilters } = useCarsFilterHandlers();

  const { search_term, dealer_ids, location_ids, date_from, date_to } = carsFilters;

  return (
    <div className="CarsLeadsFilters">
      <NavPortal>
        <SearchFilter value={search_term} handleSearchChange={handleSearchChange} />
      </NavPortal>

      <div className="toolbar-container">
        <Grid columns={16} className="toolbar-grid">
          <GridColumn width={4} className="no-left-gutter right-gutter">
            <LeadTypeFilter />
          </GridColumn>
          <GridColumn width={4} className="left-gutter right-gutter">
            <DatePicker fluid selectsRange onDateChange={handleDateRangeChange} startDate={date_from} endDate={date_to} customInput={<CustomDateRangeInput />} />
          </GridColumn>
          <GridColumn width={8} className="left-gutter no-right-gutter">
            <DealersAndLocationsDropdown
              values={{ dealerIds: dealer_ids, locationIds: location_ids }}
              handleOnChange={({ dealerIds, locationIds }) => handleDealerLocationChange({ dealerIds, locationIds })}
              allowSelectAllDealers={false}
            />
          </GridColumn>
        </Grid>

        <div className="toolbar-reset-export-buttons-container">
          <ResetFiltersButton handleReset={handleResetFilters} />
          {user?.csv_download && canExportLeads && <ExportDataButton handleOnClick={handleOpenExportModal} disabled={!dealer_ids.length && !location_ids.length} />}
        </div>
      </div>

      <LeadsExportModal open={showExportModal} onClose={handleCloseExportModal} onExport={() => exportLeadsCars(carsFilters)} />
    </div>
  );
};
